import Lara from "@/presets/lara";

export const excursionIncludedItemPresets = {
  ...Lara,
  card: {
    ...Lara.card,
    root: {
      class: [
        ...(Array.isArray(Lara.card.root?.class)
          ? Lara.card.root.class
          : Lara.card.root?.class
            ? [Lara.card.root.class]
            : []),
        "flex flex-col h-full",
      ],
    },
    title: { class: ["text-2xl font-bold"] },
    body: { class: ["p-4 gap-4 flex flex-col flex-1 min-h-0"] },
    caption: { class: ["p-0 text-2xl font-bold shrink-0"] },
    content: { class: ["p-0 mt-auto shrink-0"] },
    footer: { class: ["shrink-0"] },
  },
};
